import { useState, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Divider from '@mui/material/Divider';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const iconStyle = {
    color: '#D46666',
    fontSize: '20px',
    marginRight: '-5px'
};

export default function CouponList({ name, data, handleDelete, t, config, pageSetting }) {
    const [totalAmt, setTotalAmt] = useState(null);
    const [totalQty, setTotalQty] = useState(0);

    useEffect(() => {
        if (data) {
            console.log(data, data.length);
            setTotalAmt(calcTotal(data));
            setTotalQty(calcTotalQty(data));
        }
    }, [data]);

    const calcTotal = (data) => {
        let total = 0;
        for (let i of data) {
            total += i.amt;
        }
        return total;
    };

    const calcTotalQty = (data) => {
        let total = 0;
        for (let i of data) {
            total += Number(i.qty);
        }
        return total;
    };

    const list =
        data &&
        data.map((item, i) => {
            return (
                <List key={i}>
                    <ListItem
                        style={{
                            padding: '12px 40px 12px 5px',
                            fontWeight: 'bold',
                            wordBreak: 'break-all'
                        }}
                    >
                        {item.name}
                        {pageSetting.coupons_delBtn_display && (
                            <ListItemSecondaryAction style={{ width: '15px' }}>
                                <div onClick={() => handleDelete(item)}>
                                    <FontAwesomeIcon icon={faTrashAlt} style={iconStyle} />
                                </div>
                            </ListItemSecondaryAction>
                        )}
                    </ListItem>
                    <Divider light />
                </List>
            );
        });

    return name === 'scanner' ? (
        <div id="couponData" style={window.screen.width < 641 ? { padding: '0 15px' } : { padding: '0 20px' }}>
            <h4 style={{ textAlign: 'left', color: config.theme.color }}>
                {t('scannerPage_couponList_label')}
                {/* {pageSetting.coupons_qty_display && `(${data ? data[0].qty : 0})`} */}
                {pageSetting.coupons_qty_display && `(${totalQty})`}
                <span
                    style={{
                        float: 'right',
                        marginRight: pageSetting.list_coupons_qty.display ? '18px' : '5px'
                    }}
                >
                    {pageSetting.list_coupons_qty.display
                        ? `${t('scannerPage_coupons_qty_label')}: ${totalQty}`
                        : `${t('scannerPage_coupons_subtotal_label')}: $${totalAmt}`}
                </span>
            </h4>
            <Divider light />

            {list}
        </div>
    ) : (
        <div className="list">
            <h2>
                {t('scannerPage_couponList_label')}
                {pageSetting.coupons_qty_display && `(${totalQty})`}
            </h2>
            <Divider light />

            {list}

            {data?.length > 0 && parseInt(data[0].minSpendingAmount) > 0 && (
                <p className="boldThemeTxt left">
                    {t('redeem_coupons_minSpendingAmount_label', {
                        minSpendingAmount: parseInt(data[0].minSpendingAmount)
                    })}
                </p>
            )}

            <div className="totalDiv">
                <p className="boldThemeTxt left">
                    {pageSetting.list_coupons_qty.display
                        ? t(`${pageSetting.list_coupons_qty.label}`)
                        : t('redeem_coupons_subtotal_label')}
                </p>
                <p
                    className="boldThemeTxt right"
                    style={{
                        marginRight: pageSetting.list_coupons_qty.display ? '18px' : '5px'
                    }}
                >
                    {pageSetting.list_coupons_qty.display ? totalQty : `$${totalAmt}`}
                </p>
            </div>
            <Divider light />
        </div>
    );
}
